export function filterDisplayableDomains(response) {
  if (!response) {
    return [];
  }

  let domains = response.returndata;

  if (!response.returncode) {
    domains = [{ domain: response.returndata }];
  }

  if (!Array.isArray(domains)) {
    return [];
  }

  return domains.filter((domain) => {
    if (!domain || typeof domain !== "object") {
      return false;
    }

    if (domain.verification === undefined || domain.verification === null) {
      return true;
    }

    return String(domain.verification) === "0";
  });
}
